<template>
    <div>
        <div>
            <div style="display: flex;justify-content: space-between">
                <div>
                    <el-input placeholder="请输入图形名进行搜索，可以直接回车搜索..." prefix-icon="el-icon-search"
                              clearable
							  size="medium"
                              @clear="initEmps"
                              style="width: 350px;margin-right: 10px" v-model="keyword"
                              @keydown.enter.native="initEmps" :disabled="showAdvanceSearchView"></el-input>
                    <el-button icon="el-icon-search" type="primary" @click="initEmps" :disabled="showAdvanceSearchView">
                        搜索
                    </el-button>
                </div>
                <div>
                    <el-button type="primary" icon="el-icon-plus" @click="showAddEmpView">
                        添加图形输出
                    </el-button>
                </div>
            </div>
        </div>
        <div style="margin-top: 10px">
            <el-table
                    :data="emps"
                    stripe
                    border
                    v-loading="loading"
                    element-loading-text="正在加载..."
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.8)"
                    style="width: 100%">
                <!-- <el-table-column
                        type="selection"
                        width="55">
                </el-table-column> -->
				<el-table-column
				        prop="kgmCode"
				        align="center"
				        label="图形编号"
				        min-width="33.33%">
				</el-table-column> 
                <el-table-column
                        prop="kgmName"
                        align="center"
                        label="图形名称"
                        min-width="33.33%">
                </el-table-column>
                <el-table-column
						align="center"
						min-width="33.33%"
                        label="操作">
                    <template slot-scope="scope">
                        <el-button @click="showEditEmpView(scope.row)" style="padding: 3px" size="mini">编辑</el-button>
                        <el-button @click="deleteEmp(scope.row)" style="padding: 3px" size="mini" type="danger">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div style="display: flex;justify-content: flex-end">
                <el-pagination
                        background
                        @current-change="currentChange"
                        @size-change="sizeChange"
                        layout="sizes, prev, pager, next, jumper, ->, total, slot"
                        :total="total">
                </el-pagination>
            </div>
        </div>
        <el-dialog
                :title="title"
                :visible.sync="dialogVisible"
				:before-close="handleClose"
                width="80%">
            <div>
                <el-form :model="emp" :rules="rules" ref="empForm">
                    <el-row>
                        <el-col :span="7">
                            <el-form-item label="图形输出编号:" prop="kgmCode">
								<div class="input_box">
									<el-input size="mini" style="width: 150px" prefix-icon="el-icon-edit" v-model="emp.kgmCode"
									          placeholder="请输入图形输出编号" maxlength="50" show-word-limit></el-input>
								</div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="7">
                            <el-form-item label="图形输出名称:" prop="kgmName">
								<div class="input_box">
									<el-input size="mini" style="width: 150px" prefix-icon="el-icon-edit" v-model="emp.kgmName"
									          placeholder="请输入图形输出名称" maxlength="50" show-word-limit></el-input>
								</div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
				<el-button @click="handleClose">取 消</el-button>
				<el-button type="primary" @click="doAddEmp">确 定</el-button>
			  </span>
        </el-dialog>
	</div>
</template>

<script>
	//所需页面导入
	import vue from 'vue'
	import QRCode from 'qrcodejs2'
    export default {
        name: "Tenants",
        data() {
            return {
                searchValue: {
					ktiContacts:'',
					ktiContactWay:'',
					ktiIsEnable:''
                },
                title: '',
				showAdvanceSearchView: false,
                allDeps: [],
                emps: [],
                loading: false,
                dialogVisible: false,
				qrcodeDialogVisible:false,
                total: 0,
                page: 1,
                keyword: '',
                size: 10,
                emp: {
					kgmId:'',
					kgmCode:'',
					kgmName:''
                },
                defaultProps: {
                    children: 'children',
                    label: 'name'
                },
                rules: {
                    kgmCode: [{required: true, message: '请输入图形输出编号', trigger: 'blur'}],
					kgmName: [{required: true, message: '请输入图形输出名称', trigger: 'blur'}]
                },
				fileList:[]
            }
        },
        mounted() {
            this.initEmps();
            this.initData();
        },
        methods: {
			
			handleClose(done) {
				console.log("handleClose")
				this.dialogVisible = false
				this.emptyEmp()
			},
            emptyEmp() {
                this.emp = {
					kgmId:'',
                    kgmCode:'',
                    kgmName:''
                }
            },
            showEditEmpView(data) {
				console.log(data)
                this.title = '编辑图形输出信息';
                this.emp = data;
                this.dialogVisible = true;
            },
            deleteEmp(data) {
                this.$confirm('此操作将永久删除【' + data.kgmName + '】, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.deleteRequest("/graphicModel/basic/del/" + data.kgmId).then(resp => {
                        if (resp) {
                            this.initEmps();
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            doAddEmp() {
				console.log(this.emp)
                if (this.emp.kgmId) {
                    this.$refs['empForm'].validate(valid => {
                        if (valid) {
                            this.postRequest("/graphicModel/basic/update", this.emp).then(resp => {
                                if (resp) {
                                    this.dialogVisible = false;
									this.emptyEmp();
                                    this.initEmps();
                                }
                            })
                        }
                    });
                } else {
                    this.$refs['empForm'].validate(valid => {
                        if (valid) {
                            this.postRequest("/graphicModel/basic/add", this.emp).then(resp => {
                                if (resp) {
                                    this.dialogVisible = false;
									this.emptyEmp();
                                    this.initEmps();
                                }
                            })
                        }
                    });
                }
            },
            initData() {
				
            },
            sizeChange(currentSize) {
                this.size = currentSize;
                this.initEmps();
            },
            currentChange(currentPage) {
                this.page = currentPage;
                this.initEmps('advanced');
            },
            showAddEmpView() {
                this.emptyEmp();
                this.title = '添加图形输出';
                this.dialogVisible = true;
            },
            initEmps(type) {
                this.loading = true;
                let url = '/graphicModel/basic/getGraphicModels?page=' + this.page + '&size=' + this.size + '&keyword=' + this.keyword;
                this.getRequest(url).then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.emps = resp.data;
                        this.total = resp.total;
                    }
                });
            }
        }
    }
</script>

<style scoped lang="scss">
    /* 可以设置不同的进入和离开动画 */
    /* 设置持续时间和动画函数 */
    .slide-fade-enter-active {
        transition: all .8s ease;
    }

    .slide-fade-leave-active {
        transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active for below version 2.1.8 */
    {
        transform: translateX(10px);
        opacity: 0;
    }
	.el-form-item {
		display: flex;
		.input_box {
			width: 14.5rem;
			.el-input {
				width: 100% !important;
			}
		}
	}
	.advance_seit_box {
		line-height: 2.5rem;
		height: 2.5rem;
		font-size: 0.875rem;
		.box_tit {
			font-size: 0.875rem;
		}
	}
	.advance_btn_warp {
		line-height: 2.5rem;
		height: 2.5rem;
	}
</style>
